var _path, _polyline, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: "48px",
    height: "48px",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId,
    stroke: "#2329D6",
    strokeWidth: 1,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    fill: "none",
    color: "#2329D6",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "downloadIconTitle"
  }, "Download") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "downloadIconTitle"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,3 L12,16"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "7 12 12 17 17 12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20,21 L4,21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.2754adc26ad3edae0e359453e4d68fd9.svg";
export { ForwardRef as ReactComponent };